module.exports = __webpack_public_path__ + "static/scale-model-of-point-defiance-zoo-&-aquarium-in-tacoma-washington-7e4a8f9d1460aba6242aab5e14babeae.png";